import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'
import { HiCalendar } from 'react-icons/hi'
import { useLocalizedLink } from '../../hooks/useLocalizedLink'
import { getLocalizedVideoCollections } from '../../data/videosData'
import VkVideoEmbed from '../../components/VkVideoEmbed/VkVideoEmbed'
import SEO from '../../components/SEO/SEO'
import { seoBreadcrumbPair } from '../../utils/seoUtils'
import './Videos.css'

function Videos() {
  const { t, i18n } = useTranslation()
  const getLocalizedLink = useLocalizedLink()
  const collections = getLocalizedVideoCollections(i18n.language)

  const breadcrumbItems = useMemo(
    () => seoBreadcrumbPair(t('common.home'), t('common.videos'), 'videos'),
    [t]
  )

  return (
    <div className="videos-page">
      <SEO
        title={t('common.videos')}
        description={t('videos.description')}
        breadcrumbItems={breadcrumbItems}
      />
      <div className="container">
        <div className="videos-hero">
          <h1>{t('common.videos')}</h1>
          <p className="videos-intro">{t('videos.intro')}</p>
        </div>

        <div className="videos-list">
          {collections.length > 0 ? (
            collections.map((item) => (
              <article key={item.id} className="video-collection-card">
                <div className="video-collection-player">
                  {item.videos.map((video) => (
                    <div key={video.id} className="video-collection-player-item">
                      {item.videos.length > 1 && (
                        <h3 className="video-collection-player-heading">{video.title}</h3>
                      )}
                      <VkVideoEmbed
                        url={video.url}
                        title={video.title}
                        showExternalLink={false}
                      />
                    </div>
                  ))}
                </div>

                <div className="video-collection-card-content">
                  <div className="video-collection-date">
                    <HiCalendar className="date-icon" />
                    <span>{item.date}</span>
                  </div>
                  <h2 className="video-collection-title">{item.title}</h2>
                  <p className="video-collection-excerpt">
                    {item.description.split('\n\n')[0]}
                  </p>
                  <Link
                    to={`${getLocalizedLink('/videos')}/${item.id}`}
                    className="video-collection-link"
                  >
                    {t('videos.moreDetails', 'Подробнее')} →
                  </Link>
                </div>
              </article>
            ))
          ) : (
            <div className="no-videos">
              <p>{t('videos.noVideos')}</p>
            </div>
          )}
        </div>
      </div>
    </div>
  )
}

export default Videos
